module.exports = __webpack_public_path__ + "media/images/products/gv500ma/gv500ma-1-1000x1000-cb84d2fb0d705d1976fbe7a546e5d58c.png";